


// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { Mail, Linkedin, Github } from "lucide-react";

// const Portfolio = () => {
//   const fullTitle = "MERN Stack Developer";
//   const [typedTitle, setTypedTitle] = useState("");

//   useEffect(() => {
//     let current = 0;
//     const interval = setInterval(() => {
//       setTypedTitle(fullTitle.slice(0, current + 1));
//       current++;
//       if (current === fullTitle.length) clearInterval(interval);
//     }, 80);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="relative w-full min-h-screen bg-gradient-to-b from-black via-gray-900 to-black flex flex-col px-5 sm:px-8 md:px-24 pb-20">
      
//       {/* Title */}
//       <motion.h1
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 1 }}
//         className="text-4xl sm:text-5xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 mt-12"
//       >
//         {typedTitle}
//         <span className="animate-pulse text-white">|</span>
//       </motion.h1>

//       <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start py-14 gap-12">
        
//         {/* Introduction */}
//         <motion.div
//           initial={{ opacity: 0, x: -60 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 1 }}
//           className="flex-1 bg-white/10 backdrop-blur-lg border border-white/20 p-8 rounded-2xl shadow-lg hover:shadow-blue-500/40 transition-shadow duration-300"
//         >
//           <h2 className="flex items-center gap-3 mb-6 text-3xl font-bold text-white">
//             <motion.div
//               animate={{ y: [-8, 0, -8] }}
//               transition={{ repeat: Infinity, duration: 1.2 }}
//               className="w-4 h-4 rounded-full bg-blue-500"
//             />
//             Introduction <span className="text-blue-500">Overview</span>
//           </h2>
//           <p className="text-gray-200 text-lg leading-relaxed">
//             I'm a skilled <span className="text-blue-400 font-semibold">JavaScript</span> developer with expertise in{" "}
//             <span className="text-blue-400 font-semibold">React, Node.js, Express.js</span>, and{" "}
//             <span className="text-blue-400 font-semibold">MongoDB</span>. I build efficient, scalable, and
//             user-friendly applications that solve real-world problems. Let's work together to bring your ideas to life!
//           </p>
//         </motion.div>

//         {/* Contact */}
//         <motion.div
//           initial={{ opacity: 0, x: 60 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 1 }}
//           className="w-full max-w-md bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-8 shadow-lg hover:shadow-purple-500/40 transition-shadow duration-300"
//         >
//           <h2 className="text-white text-2xl font-bold mb-4 text-center">
//             Get in Touch
//           </h2>
//           <p className="text-gray-400 text-center mb-6">
//             Feel free to reach out through any of the platforms below.
//           </p>
//           <div className="flex flex-col gap-4">
//             {[
//               { name: "Email", icon: <Mail />, link: "mailto:jigu4200@gmail.com", color: "from-blue-500 to-blue-700" },
//               { name: "GitHub", icon: <Github />, link: "https://github.com/Zignesh100", color: "from-gray-600 to-gray-800" },
//               { name: "LinkedIn", icon: <Linkedin />, link: "https://www.linkedin.com/in/zignesh-v55", color: "from-blue-700 to-blue-900" }
//             ].map((btn, i) => (
//               <motion.a
//                 key={i}
//                 href={btn.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 whileHover={{ scale: 1.05 }}
//                 className={`flex items-center justify-center gap-2 text-white px-4 py-3 rounded-md bg-gradient-to-r ${btn.color} shadow-md`}
//               >
//                 {btn.name} {btn.icon}
//               </motion.a>
//             ))}
//           </div>
//         </motion.div>
//       </div>

//       {/* Instagram */}
//       <motion.div
//         initial={{ opacity: 0, y: 40 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 1 }}
//         className="mt-8 p-6 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 rounded-2xl shadow-lg max-w-lg mx-auto"
//       >
//         <p className="text-white text-lg font-bold text-center">
//           I also share Full Stack development tutorials and tips on my Instagram.
//         </p>
//         <div className="mt-4 flex justify-center">
//           <a
//             href="https://www.instagram.com/code_ki_pathshala/"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="inline-flex items-center gap-2 text-white font-semibold"
//           >
//             <img
//               src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
//               alt="Instagram Logo"
//               className="h-6 w-6"
//             />
//             @code_ki_pathshala
//           </a>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default Portfolio;



import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Mail, Linkedin, Github } from "lucide-react";

const Portfolio = () => {
  const fullTitle = "MERN Stack Developer";
  const [typedTitle, setTypedTitle] = useState("");

  useEffect(() => {
    let current = 0;
    const interval = setInterval(() => {
      setTypedTitle(fullTitle.slice(0, current + 1));
      current++;
      if (current === fullTitle.length) clearInterval(interval);
    }, 80);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full min-h-screen bg-gradient-to-b from-black via-gray-900 to-black flex flex-col px-4 sm:px-6 md:px-10 lg:px-20 pb-16">
      {/* Title */}
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 mt-8 sm:mt-12"
      >
        {typedTitle}
        <span className="animate-pulse text-white">|</span>
      </motion.h1>

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row justify-between items-stretch py-10 gap-8">
        {/* Introduction */}
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className="flex-1 bg-white/10 backdrop-blur-lg border border-white/20 p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-blue-500/40 transition-shadow duration-300"
        >
          <h2 className="flex items-center gap-3 mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold text-white">
            <motion.div
              animate={{ y: [-8, 0, -8] }}
              transition={{ repeat: Infinity, duration: 1.2 }}
              className="w-3 sm:w-4 h-3 sm:h-4 rounded-full bg-blue-500"
            />
            Introduction <span className="text-blue-500">Overview</span>
          </h2>
          <p className="text-gray-200 text-base sm:text-lg leading-relaxed">
            I'm a skilled <span className="text-blue-400 font-semibold">JavaScript</span> developer with expertise in{" "}
            <span className="text-blue-400 font-semibold">React, Node.js, Express.js</span>, and{" "}
            <span className="text-blue-400 font-semibold">MongoDB</span>. I build efficient, scalable, and
            user-friendly applications that solve real-world problems. Let's work together to bring your ideas to life!
          </p>
        </motion.div>

        {/* Contact */}
        <motion.div
          initial={{ opacity: 0, x: 60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className="w-full lg:w-[350px] bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-purple-500/40 transition-shadow duration-300"
        >
          <h2 className="text-white text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-center">
            Get in Touch
          </h2>
          <p className="text-gray-400 text-center mb-5 sm:mb-6 text-sm sm:text-base">
            Feel free to reach out through any of the platforms below.
          </p>
          <div className="flex flex-col gap-3 sm:gap-4">
            {[
              { name: "Email", icon: <Mail size={18} />, link: "mailto:jigu4200@gmail.com", color: "from-blue-500 to-blue-700" },
              { name: "GitHub", icon: <Github size={18} />, link: "https://github.com/Zignesh100", color: "from-gray-600 to-gray-800" },
              { name: "LinkedIn", icon: <Linkedin size={18} />, link: "https://www.linkedin.com/in/zignesh-v55", color: "from-blue-700 to-blue-900" }
            ].map((btn, i) => (
              <motion.a
                key={i}
                href={btn.link}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                className={`flex items-center justify-center gap-2 text-white px-3 sm:px-4 py-2 sm:py-3 rounded-md bg-gradient-to-r ${btn.color} shadow-md text-sm sm:text-base`}
              >
                {btn.name} {btn.icon}
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>

      {/* Instagram */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="mt-8 p-4 sm:p-6 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 rounded-2xl shadow-lg w-full sm:max-w-md mx-auto"
      >
        <p className="text-white text-base sm:text-lg font-bold text-center">
          I also share Full Stack development tutorials and tips on my Instagram.
        </p>
        <div className="mt-3 sm:mt-4 flex justify-center">
          <a
            href="https://www.instagram.com/code_ki_pathshala/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white font-semibold text-sm sm:text-base"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
              alt="Instagram Logo"
              className="h-5 w-5 sm:h-6 sm:w-6"
            />
            @code_ki_pathshala
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default Portfolio;
